import React,{useState} from 'react';
import {Box,Grid,FormControl,InputLabel,Button,Tooltip} from  "@mui/material";
import {CalendarMonth as CalendarMonthIcon} from "@mui/icons-material";
import SearchUnit from './SearchUnit';
import SearchSupplier from './SearchSupplier';
import SearchDirection from './SearchDirection';
import InputAS2Id from './InputAS2Id';
import InputDate from './InputDate';
import {useAS2CommStatusContextProvider} from '../As2CommStatusContextProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';

import dayjs from 'dayjs';



export const As2CommStatusSearchComponent=()=>{

    const {setAs2QueryParams} =  useAS2CommStatusContextProvider();
    const [as2SenderId,setAs2SenderId]=useState("");
    const [as2ReceiverId,setAs2ReceiverId]=useState("");
    const currentDate = new Date();
    const [defaultFromDate,] = useState(new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate()));
    const [defaultToDate,]= useState(new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate(),23,59,59));

const [fromDate, setFromDate] = useState(dayjs(defaultFromDate));
const [toDate, setToDate] = useState(dayjs(defaultToDate));

    const [supplierList, setSupplierList] = useState([]);
    const [inputSupplier,setInputSupplier]=useState("");
    const [inputUnit,setInputUnit]=useState("");
    const [direction,setDirection]=useState("A");
    const [supplierNumber,setSupplierNumber]=useState("");
    const [unitCode,setUnitCode] = useState("");

    const onSearchAs2 =(event)=>{
        event.preventDefault();
        const as2QueryParams={
            "fromDate": fromDate.toDate(), 
            "toDate": toDate.toDate(), 
            "supplierNumber":supplierNumber,
            "direction":direction,
            "as2SenderId":as2SenderId,
            "as2ReceiverId":as2ReceiverId,
            "unitCode":unitCode,
            "forceUpdate": Date.now()
        };
        setAs2QueryParams(as2QueryParams);

    }


    const onClearAs2 = (event) =>{
        event.preventDefault();
        setInputSupplier("");
        setDirection("A");
        setAs2ReceiverId("");
        setAs2SenderId("");
        setFromDate(dayjs(defaultFromDate));
        setToDate(dayjs(defaultToDate));
        setSupplierNumber("");
        setSupplierList([]);
        setInputUnit("");
        setUnitCode("");
        const as2QueryParams={
            "fromDate": new Date(),
            "toDate": new Date(),
            "supplierNumber":"",
            "direction":"A",
            "as2SenderId":"",
            "as2ReceiverId":"",
            "unitCode":"",
            "forceUpdate": 0
        };
        setAs2QueryParams(as2QueryParams);

    }

    return (
<Box sx={{ overflow: "auto" }}>
  <Grid container spacing={4} alignItems="flex-start" justifyContent="center">
    
    <Grid >
      <Tooltip title="Set the beginning date/time. Range must not exceed 30 days" placement="left-start">
        <FormControl fullWidth required>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="From"
              value={fromDate}
              onChange={(newValue) => setFromDate(newValue)}
              slots={{
                openPickerIcon: CalendarMonthIcon,
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  required: true,
                 
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid >
      <Tooltip title="Set the end date/time. Range must not exceed 30 days" placement="left-start">
        <FormControl fullWidth required>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="To"
              value={toDate}
              onChange={(newValue) => setToDate(newValue)}
              slots={{
                openPickerIcon: CalendarMonthIcon,
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  required: true,
                 
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid >
      <Tooltip title="Search and select a supplier. 3 chars min to trigger the search." placement="left-start">
        <FormControl fullWidth required>
          <InputLabel style={{ fontWeight: "bold", fontSize: "medium" }}>Supplier</InputLabel>
          <SearchSupplier
            supplierList={supplierList}
            inputSupplier={inputSupplier}
            setSupplierList={setSupplierList}
            setInputSupplier={setInputSupplier}
            setSupplierNumber={setSupplierNumber}
          />
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid >
      <Tooltip title="Select an EDI Unit Code, e.g. AG00" placement="left-start">
        <FormControl fullWidth>
          <InputLabel style={{ fontWeight: "bold", fontSize: "medium" }}>Unit</InputLabel>
          <SearchUnit
            inputUnit={inputUnit}
            setInputUnit={setInputUnit}
            setUnitCode={setUnitCode}
          />
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid >
      <Tooltip title="Select a direction. Inbound (from Partner to Deere), Outbound (from Deere to Partner)" placement="left-start">
        <FormControl fullWidth>
          <InputLabel htmlFor="direction" style={{ fontWeight: "bold", fontSize: "medium" }}>Direction</InputLabel>
          <SearchDirection direction={direction} setDirection={setDirection} />
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid >
      <Tooltip title="Set the AS2 Sender Id, e.g. JOHNDEERE_PROD" placement="left-start">
        <FormControl fullWidth>
          <InputLabel htmlFor="senderAs2Id" style={{ fontWeight: "bold", fontSize: "medium" }}>AS2 Sender Id</InputLabel>
          <InputAS2Id
            inputProps={{ maxLength: 255 }}
            value={as2SenderId}
            onChange={(event) => setAs2SenderId(event.target.value.toUpperCase())}
          />
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid >
      <Tooltip title="Set the AS2 Receiver Id, e.g. WIRTGEN_PROD" placement="left-start">
        <FormControl fullWidth>
          <InputLabel htmlFor="receiverAs2Id" style={{ fontWeight: "bold", fontSize: "medium" }}>AS2 Receiver Id</InputLabel>
          <InputAS2Id
            inputProps={{ maxLength: 255 }}
            value={as2ReceiverId}
            onChange={(event) => setAs2ReceiverId(event.target.value.toUpperCase())}
          />
        </FormControl>
      </Tooltip>
    </Grid>

    <Grid>
      <Tooltip title="Click the button to submit the search" placement="left-start">
        <Button variant="primary" sx={{ mr: 2 }} onClick={onSearchAs2}>
          Search
        </Button>
      </Tooltip>
      <Tooltip title="Click the button to clear the search criteria fields" placement="left-start">
        <Button variant="secondary" onClick={onClearAs2}>
          Clear
        </Button>
      </Tooltip>
    </Grid>

  </Grid>
</Box>

    );

}


export  default As2CommStatusSearchComponent;
